import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

interface GroupDividerProps {
  unitName: string;
  teamName: string;
}

export const GroupDivider = (props: GroupDividerProps): JSX.Element => {
  return (
    <DividerRow>
      <UnitBadge>{props.unitName}</UnitBadge>
      <TeamName>{props.teamName}</TeamName>
    </DividerRow>
  );
};

const DividerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: sticky;
  left: 0;
  width: stretch;
  margin-top: 12px;
  padding: 6px 16px;
  border-radius: 12px;
  background: ${ColorV2.Blue6};
`;

const UnitBadge = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue3};
  background: ${ColorV2.Blue6};
  border-radius: 10px;
  padding: 2px 8px;
`;

const TeamName = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;
